<template>
  <div>
    <el-card>
      <div
          slot="header"
          class="clearfix">
        <span class="header-item">Accessories</span>
        <span class="ring-card__header-buttons">

          <AddNewAccessory
              :customer-profile-id="customerProfileId"
              :callback="accessoryRegistered" />

          <el-divider direction="vertical" />

          <RefreshButton @click.native="fetchAccessories()" />

        </span>
      </div>
      <div
          v-loading="request.loading"
          class="card-content">
        <el-table
            :data="accessoriesView"
            stripe>
          <el-table-column type="expand">
            <template slot-scope="props">
              <accessory-history-tab-pane :device-id="props.row.device_id" />
            </template>
          </el-table-column>
          <el-table-column
              prop="device_id"
              label="Device ID" />
          <el-table-column
              prop="kind"
              label="Type" />
          <el-table-column
              prop="state"
              label="State" />
          <el-table-column>
            <template slot-scope="props">
              <time-zone-formatter :current-time="props.row.created_at" />
            </template>
          </el-table-column>

          <el-table-column
              v-if="true"
              label="Actions"
              align="center">
            <template slot-scope="scope">
              <el-tooltip
                  class="item"
                  effect="dark"
                  content="Unregister Accessory"
                  placement="top-start">
                <el-popover
                    v-model="scope.row.deletion.formOpen"
                    title="Confirmation"
                    placement="left">
                  <div v-loading="scope.row.deletion.ongoing">
                    <div style="text-align: right; margin: 0">
                      <p>Are you sure you want to <strong>delete</strong> this accessory? </p>
                      <el-button
                          size="mini"
                          type="text"
                          @click="scope.row.deletion.formOpen = false">
                        cancel
                      </el-button>
                      <el-button
                          type="primary"
                          size="mini"
                          @click="deleteAccessory(scope.$index, scope.row)">
                        confirm
                      </el-button>
                    </div>
                    <div class="add-new-accessory__alert">
                      <el-alert
                          v-if="scope.row.deletion.failed"
                          title="Accessory could be deleted. Contact Admin for help."
                          type="error" />
                    </div>
                  </div>

                  <a slot="reference">
                    <i class="el-icon-delete"></i>
                  </a>
                </el-popover>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { startCase, remove, cloneDeep, get } from "lodash";
import axios from "axios";
import AccessoryHistoryTabPane from "@/containers/Customer/Devices/Accessories/AccHistoryTabPane";
import AddNewAccessory from "@/containers/Customer/Devices/Accessories/AddNewAccessory";
import RefreshButton from "@/containers/Customer/RefreshButton";

export default {
  name: "Accessories",
  components: {
    AccessoryHistoryTabPane,
    AddNewAccessory,
    RefreshButton,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      accessories: [],
      accessoriesView: [],
      request: {
        loading: false,
        failed: false,
      },
    };
  },
  computed: {
    customerId() {
      return get(this.customer, "id", null);
    },
    customerProfileId() {
      return get(this.customer, "profile.id", null);
    },
    timeZone() {
      return this.$store.getters["ui/currentTimezone"];
    },
    endPoint() {
      return `/v2/customers/${this.customerId}/accessories`;
    },
  },
  watch: {
    "customer.id": function (value) {
      if (value) this.fetchAccessories();
    },
  },
  created() {
    this.fetchAccessories();
  },
  methods: {
    accessoryRegistered(acc) {
      if (get(acc, "device_id", null))
        this.accessoriesView.unshift({
          id: acc.id,
          device_id: acc.device_id,
          kind: startCase(acc.kind),
          state: startCase(acc.state),
          created_at: acc.created_at,
          deletion: {
            formOpen: false,
            failed: false,
            ongoing: false,
          },
        });
    },
    deleteAccessory(index, info) {
      info.deletion.ongoing = true;
      info.deletion.failed = false;
      axios
        .delete(`/v2/device_profiles/${info.id}`)
        .then(() => {
          // remove from list
          remove(this.accessoriesView, (item) => info.id === item.id);
          // end remove
          info.deletion.formOpen = false;
          this.$message({
            showClose: true,
            message: "Accessory deleted",
            type: "success",
          });
        })
        .catch((error) => {
          info.deletion.failed = true;
        })
        .finally(() => {
          info.deletion.ongoing = false;
        });
    },
    fetchAccessories() {
      if (!this.customerId) return;
      this.request.loading = true;
      this.request.failed = false;
      axios
        .get(this.endPoint)
        .then((response) => {
          this.accessories = response.data;
          this.buildAccessoriesView();
        })
        .catch((error) => {
          console.error("Accessories load failed.", error);
          this.request.failed = true;
        })
        .finally(() => (this.request.loading = false));
    },
    buildAccessoriesView() {
      this.accessoriesView = this.accessories.map((self) => {
        return {
          id: self.profile.id,
          device_id: self.profile.device_id,
          kind: startCase(self.profile.kind),
          state: startCase(self.profile.state),
          created_at: self.profile.created_at,
          deletion: {
            formOpen: false,
            failed: false,
            ongoing: false,
          },
        };
      });
    },
  },
};
</script>
